import { createStore, applyMiddleware, compose } from "redux";
import { combineReducers } from "redux";
import thunk from "redux-thunk";
import storage from "redux-persist/lib/storage"; // Usa o localStorage
import { persistReducer, persistStore } from "redux-persist";

import userReducer from "./user";
import tokenReducer from "./token";
import counterRequestReducer from "./counterRequest";
import filtroReducer from "./filtros";
import MenuReducer from "./menu";

/* COMBINA AS VARIAVEIS GLOBAIS DO SISTEMA */
const rootReducer = combineReducers({
  counterRequestReducer,
  userReducer,
  tokenReducer,
  filtroReducer,
  MenuReducer,
});

const persistConfig = {
  key: "root",
  storage,
  blacklist: ["counterRequestReducer"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const composeMiddlewares = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(persistedReducer, composeMiddlewares(applyMiddleware(thunk)));

export const persistor = persistStore(store);
export default store;
